<template>
    <div class="pieClass">


        <div v-if="rtgId" class="pie">

            <highcharts class="chart" ref="chart" :options="chartOptions"></highcharts>

        </div>

        <div id="container">

            <DxPopup v-model:visible="popupVisible"
                     :shading="true"
                     shading-color="rgb(18,24,34,0.2)"
                     :drag-enabled="false"
                     :show-close-button="false"
                     :show-title="true"
                     :width="500"
                     :height="280"
                     title="Themen"
                     v-model:value="gridBoxValue"
                     :defer-rendering="false"
                     :show-clear-button="true"
                     placeholder="Select a value...">
                <DxPosition my="center" />

                <DxToolbarItem widget="dxButton"
                               toolbar="bottom"
                               location="after"
                               :options="closeButtonOptions" />
                <template #content>

                    <DxDataGrid :data-source="gridDataSource"
                                :ref="gridKey"
                                @cell-click="onCellClick"
                                :cssClass="readAccessClasses"
                                :hover-state-enabled="true"
                                v-model:selected-row-keys="gridBoxValue"
                                height="100%">
                        <DxColumn data-field="TopicID" caption='ID' data-type="number" alignment="left" :width="60" />
                        <DxColumn data-field="title" caption='Titel' />

                        <DxSelection mode="single" />
                        <DxPaging :enabled="true"
                                  :page-size="10" />
                        <DxFilterRow :visible="true" />
                        <DxScrolling mode="virtual" />
                    </DxDataGrid>
                </template>
            </DxPopup>
        </div>
    </div>
</template>

<script>

    import { Chart } from 'highcharts-vue';
    import HighchartsMore from 'highcharts/highcharts-more';
    import * as Highcharts from 'highcharts'
    import offlineExporting from "highcharts/modules/offline-exporting";
    import exporting from "highcharts/modules/exporting";
    import { DxPopup, DxPosition, DxToolbarItem } from 'devextreme-vue/popup';
    import { DxColumn, DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling, } from 'devextreme-vue/data-grid';
    const gridKey = "TopicOverviewGridMain"
    HighchartsMore(Highcharts);
    offlineExporting(Highcharts)
    exporting(Highcharts)

    Highcharts.setOptions({
        colors: [
           "rgba(203, 81, 68,0.7)",
            "rgba(32, 93, 114,0.7)",
            "rgba(153,229, 245,0.7)",
            "rgba(250, 128, 149,0.7)",
            "rgba(195, 41, 116,0.7)",
            "rgba(244, 197, 67,0.7)",
            "rgba(73, 161, 190,0.7)",
            "rgba(172, 221, 204,0.7)",
            "rgba(150, 153, 183,0.7)",
        ]
    });

    export default {
        name: 'pieChart',
        components: {
            highcharts: Chart,
            DxPopup,
            DxPosition,
            DxToolbarItem,
            DxDataGrid,
            DxSelection,
            DxPaging,
            DxFilterRow,
            DxScrolling,
            DxColumn

        },
        data() {
            return {
                rtgId: null,
                totalCount: 0,
                totalSteepThemen: 0,
                gridKey,
                currentEmployee: {},
                mpopupVisible: false,
                positionOf: '',

                sufIdData: 0,
                grafCategoriesData: [],
                gridBoxValue: [1],
                gridColumns: [],
                buttonAttributes: {
                    class: 'elementId',
                },
                chartOptions: {

                    chart: {

                        plotShadow: false,
                        backgroundColor: null,
                        type: 'pie',
                        style: {

                            fontFamily: 'var(--font-family)'
                        },
                    },
                    exporting: {

                        buttons: {

                            contextButton: {

                                enabled: false,
                                menuItems: ['downloadPNG', 'downloadSVG', 'downloadPDF', 'viewFullscreen', 'printChart']
                            }
                        },
                        exportButton: {
                            text: '<i class="fa fa-download"></i> Download',
                            // Use only the download related menu items from the default context button

                        },
                        fallbackToExportServer: false
                    },

                    credits: {
                        enabled: false
                    },
                    title: {
                        text: 'STEEP-VL VERTEILUNG ',
                        style: {
                            color: '#717c86 ',
                            fontSize: '21px',
                            fontWeight: 'bold',
                        }
                    },
                    subtitle: {
                        /*  text: 'subtitle'*/
                    },
                    tooltip: {
                        pointFormat: '<b>{series.name}</b>: {point.count}',

                    },


                    plotOptions: {
                        pie: {
                            size: "70%",
                            allowPointSelect: true,
                            cursor: 'pointer',
                            depth: 35,
                            dataLabels: {
                                formatter: function () {
                                    {
                                        return '<span class="labelPie">' + this.point.name + ":" + Highcharts.numberFormat(this.point.percentage, 2)+ "%" + '</span>';
                                    }
                                },

                                style: {

                                   
                                    textOutline: false
                                },

                            },
                            point: {
                                valueSuffix: '%',
                                events: {
                                    click: function (point) {

                                        console.log({ point });
                                        this.mpopupVisible = true;
                                        console.log(this.mpopupVisible);
                                        this.$store.dispatch("getTopicBySuchfeldStats", { RtgId: this.rtgId, LisId: this.lisId, AtrId: this.atrId, SufId: point.point.litId })

                                    }.bind(this)

                                },

                            },

                        },

                        series: {
                            cursor: 'pointer',



                        }

                    },
                    series: [{
                        name: 'Themen',
                        colorByPoint: true,
                        data: this.seriesData,
                        animation: {
                            duration: 1500
                        }
                    }]
                },

                closeButtonOptions: {
                    text: 'Close',
                    onClick: () => {
                        this.mpopupVisible = false;
                    },
                },
            };
        },
        props: ["lisId", "atrId", "sufId"],
        created() {
            window.addEventListener("rtgIdChanged", function () {

                this.rtgId = window.State.getRtgId()
                this.$store.dispatch("getSteepStats", { RtgId: this.rtgId, LisId: this.lisId, AtrId: this.atrId })
            }.bind(this), false)
        },
        methods: {
            closeOutClick() {
                this.mpopupVisible = false;
                return true
            },
            showInfo() { 
                this.mpopupVisible = true;
            },

            onCellClick: function (e) {

                var rec = this.gridDataSource.find(m => m.$id == e.data.$id);
                console.log(rec)
                this.grid.selectAll().done(x => {

                    const topicList = JSON.stringify(x.map(r => r.TopicID))
                    console.log(rec)
                    this.grid.deselectAll().done(function () {
                        window.LoadPanel.Show();
                        window.location = window.location.pathname + "?action=view&id=" + rec.TopicID + "&list=" + topicList;
                    })
                })
            },

        },
        watch: {
            seriesData: function (newVal, oldVal) {

                const chart = this.$refs["chart"].chart
                if (oldVal != newVal && chart.series) {

                    this.chartOptions.series[0].data = newVal
                    this.chartOptions.subtitle = { text: '' }
                    chart.redraw();
                }
            }
        },
        computed: {
            grid: function () {
                const ref = this.$refs[this.gridKey]
                if (ref) {
                    window.grid = ref.instance
                    return ref.instance
                }
                return null
            },
            popupVisible: function () {

                return this.mpopupVisible;
            },

            steepStats() { return this.$store.state.statisticsStore.steepStats },
            seriesData() {
                var i = 0;
                var self = this;
                self.totalCount = 0;
                var seriesData = [];

                this.steepStats.forEach(st => {

                    if (st.TopicCount)
                        self.totalCount += st.TopicCount;
                    if (st.LitId && st.TopicCount) {
                        if (st.LitShortName)
                            seriesData[i] = { name: st.LitShortName, y: st.TopicCount, count: st.TopicCount, longName: st.LitName, litId: st.LitId };
                        else
                            seriesData[i] = { name: st.LitName, y: st.TopicCount, count: st.TopicCount, longName: st.LitName, litId: st.LitId };


                        i++;
                    }
                })

                return seriesData;
            },
            topicBySuchfeldStats() { return this.$store.state.statisticsStore.topicBySuchfeldStats },
            gridDataSource() {
                var self = this;
                self.totalSteepThemen = 3;
                console.log(this.topicBySuchfeldStats)

                return this.topicBySuchfeldStats
            }
        },

    }

</script>
<style>
    .pieClass .chtBox {
        background: #ffffff1a;
    }
    /*
        .pieClass #container {
            padding: 100px;
        }

            .pieClass #container ul {
                list-style-type: none;
                text-align: center;
            }

                .pieClass #container ul li {
                    display: inline-block;
                    width: 160px;
                    margin: 10px;
                }

                    .pieClass #container ul li img {
                        width: 100px;
                    }
    */
    .pieClass .button-info {
        margin: 10px;
    }

    .pieClass .dx-popup-content p {
        margin-bottom: 10px;
        margin-top: 0;
    }


    .pieClass #popupRoot .dx-widget.dx-button.dx-button-mode-contained.dx-button-normal.dx-button-has-text.dx-state-hover {
        background-color: #00B697 !important;
        border-color: #ddd;
    }

    .pieClass .chart {
        width: 600px
    }

    .bitv .labelPie {
        fill: black;
    }

    .labelPie {
        fill: whitesmoke;
        outline: none;
    }
</style>